import { useState } from "react"
import styles from "./mission.module.css"

export default function MissionSection() {
  const [activeTab, setActiveTab] = useState(0)

  const tabs = [
    {
      title: "Our Mission",
      icon: "🎯",
      content:
        "To make in-game purchases faster, cheaper, and safer than anyone else — without cutting corners or exploiting players.",
    },
    {
      title: "What We Offer",
      icon: "🎮",
      content:
        "From Mobile Legends to Valorant, PUBG, Genshin Impact, and beyond — every game that fuels esports firepower finds a home here.",
    },
    {
      title: "Why We Exist",
      icon: "💎",
      content:
        "Because gaming should never feel like a scam or a luxury — it should feel like power, progress, and pure fun.",
    },
  ]

  return (
    <section className={styles.mission}>
      <h2 className={styles.sectionTitle}>The Core</h2>

      <div className={styles.tabContainer}>
        {tabs.map((tab, idx) => (
          <button
            key={idx}
            className={`${styles.tab} ${activeTab === idx ? styles.active : ""}`}
            onClick={() => setActiveTab(idx)}
          >
            <span className={styles.icon}>{tab.icon}</span>
            <span>{tab.title}</span>
          </button>
        ))}
      </div>

      <div className={styles.tabContent}>
        <p className={styles.content}>{tabs[activeTab].content}</p>
      </div>

      <div className={styles.stats}>
        <div className={styles.stat}>
          <div className={styles.statNumber}>50+</div>
          <div className={styles.statLabel}>Games Supported</div>
        </div>
        <div className={styles.stat}>
          <div className={styles.statNumber}>100K+</div>
          <div className={styles.statLabel}>Happy Players</div>
        </div>
        <div className={styles.stat}>
          <div className={styles.statNumber}>24/7</div>
          <div className={styles.statLabel}>Support</div>
        </div>
      </div>
    </section>
  )
}
